module.exports = __webpack_public_path__ + "img/16_bohle.9c597557.jpeg";